import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { purchaseNotifications } from '../data/testimonials';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: number;
    const showTimer = window.setInterval(() => {
      setIndex(prev => (prev + 1) % purchaseNotifications.length);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    }, 13000);
    const firstTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 5000);
    }, 6000);
    return () => {
      window.clearInterval(showTimer);
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  const item = purchaseNotifications[index];
  const minutesAgo = 2 + index % 7;
  return <AnimatePresence data-id="element-39" data-mp="165zds6yfhdlt">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.98
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-40 sm:right-auto sm:max-w-xs" role="status" aria-live="polite" data-id="element-40" data-mp="164oae88wa7v8">
          <div className="flex items-start gap-3 rounded-2xl border border-navy-900/10 bg-white p-3 shadow-card" data-id="element-41" data-mp="n869p1c2ixmu">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50" data-id="element-42" data-mp="i9l930swmbxv">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600" aria-hidden="true" data-id="element-43" data-mp="x37zlze643qh" />
            </span>
            <div className="min-w-0" data-id="element-44" data-mp="s8aqksgw1udl">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-45" data-mp="28jy7ro25j5mq">
                {item.name} just purchased the Clinical Master System™
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-slate-500" data-id="element-46" data-mp="23nps89k1laf1">
                {item.city} · {minutesAgo} minutes ago
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}